module.exports = __webpack_public_path__ + "img/modal-numbering.49755152.svg";